import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SelectObject from "../../ui/SelectObject";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface JobsTableProps {
  data: any;
  showHeader?: boolean;
}

export const JobsTable = ({ data, showHeader = false }: JobsTableProps) => {
  const [assignments, setAssignments] = useState<any[]>([]);
  const [filteredAssignments, setFilteredAssignments] = useState<any>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<number>();
  const [departments, setDepartments] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Department ID", key: "id", hide: true },
    { label: "Department", key: "department" },
    { label: "Job ID", key: "job_id", hide: true },
    { label: "Job", key: "job" },
    { label: "Case", key: "case_name" },
    { label: "Name", key: "name" },
  ];

  useEffect(() => {
    if (data) {
      const { departments, assignments } = data;
      setAssignments(assignments);
      setFilteredAssignments(assignments);
      setDepartments(departments);
    }
  }, [data]);

  const updateJob = (e: any) => {
    setSelectedDepartment(e.target.value);
    const filtered = assignments?.filter((d: any) => {
      if (e.target.value === "0") {
        return d;
      } else {
        return d.department === e.target.value;
      }
    });
    setFilteredAssignments(filtered);
  };

  return (
    <>
      {assignments ? (
        <>
          {showHeader && (
            <Row>
              <Col>
                <h5 className="app-header-text">Current Job Assignments</h5>
              </Col>
            </Row>
          )}
          <>
            <Row id="jobs-filters">
              <Col xs={4} className="mb-1">
                <SelectObject
                  label="Department (# People)"
                  initialOption="View All"
                  value={selectedDepartment}
                  options={departments}
                  onUpdate={(e: any) => updateJob(e)}
                />
              </Col>
            </Row>
            <DataTable tableHeadings={tableHeaders} tableData={filteredAssignments} title="jobs" hideTitle={true} hideDownload={true} />
          </>
        </>
      ) : (
        loadingCard()
      )}
    </>
  );
};
